"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/button/style/index.js
// module id = 17
// module chunks = 35783957827783 204390864267482 254791781388126